import { useState, useRef, useEffect } from 'react'

export default (params = []) => {
	const rootRef = useRef();
	const [topOffset, setTopOffset] = useState(0)

	useEffect(() => {
		if (rootRef.current) {
			setTopOffset(rootRef.current.offsetTop)
		}
		// eslint-disable-next-line
	}, [rootRef, ...params])

	return [rootRef, topOffset]
}